import { getSession } from './createSessionSignal'

export default function getSessionUserId() {
  const session = getSession()
  return session?.sub
}
